export const dialogStyle = {
  "& .MuiDialog-paper": {
    borderRadius: 1,
  },
  
};